import React from 'react';
import { Text } from '@zillow/constellation';
import styled from 'styled-components';

export const FromToTotal: React.FC<{ pageSize: number; pageNumber: number; totalElements: number }> = ({
  pageSize,
  pageNumber,
  totalElements,
}) => {
  if (totalElements === 0) {
    return null;
  }
  const currentFrom = pageNumber * pageSize + 1;
  const currentTo = Math.min(currentFrom + pageSize - 1, totalElements);

  return (
    <div className={'-mt-10 flex flex-row gap-1 pb-2'} role={'note'}>
      Showing <span className={'font-semibold'}>{currentFrom}</span> to{' '}
      <span className={'font-semibold'}>{currentTo}</span> of <span className={'font-semibold'}>{totalElements}</span>{' '}
      results
    </div>
  );
};

export const FromToTotalConstellation: React.FC<{ pageSize: number; pageNumber: number; totalElements: number }> = ({
  pageSize,
  pageNumber,
  totalElements,
}) => {
  if (totalElements === 0) {
    return null;
  }
  const currentFrom = pageNumber * pageSize + 1;
  const currentTo = Math.min(currentFrom + pageSize - 1, totalElements);

  return (
    <MarginText as={'div'} role={'note'}>
      Showing <strong>{currentFrom}</strong> to <strong>{currentTo}</strong> of <strong>{totalElements}</strong> results
    </MarginText>
  );
};

const MarginText = styled(Text)`
  margin-top: -40px;
`;
